module.exports = __webpack_public_path__ + "static/media/content-9.322084d8.svg";